export default __webpack_public_path__ + "static/media/Factory07.dc29911b.jpg";